import { useMemo, useCallback } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import getCourseByIdQuery from '../graphql/queries/getCourseByIdQuery';

export default function useCourse({ courseId } = {}) {
  const { data, loading, error, refetch } = useQuery(getCourseByIdQuery, {
    variables: { courseId },
    skip: !courseId,
  });
  const course = useMemo(() => data?.course || {}, [data]);
  const academyFeatures = useMemo(() => course?.academy?.features || [], [course]);

  const academyHasFeature = useCallback(
    (feature) => {
      return academyFeatures?.includes(feature);
    },
    [academyFeatures]
  );

  const academyHasFeatures = useCallback(
    (requiredFeatures) => {
      if (!requiredFeatures) {
        return true;
      }
      for (const feature of requiredFeatures) {
        if (!academyFeatures?.includes(feature)) {
          return false;
        }
      }
      return true;
    },
    [academyFeatures]
  );

  return {
    academyHasFeature,
    academyHasFeatures,

    course,
    loading,
    error: getErrorMessage({ error }),
    refetchCourse: refetch,
  };
}
